import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import TaxiRideDoc from "../Pages/TaxiRideDoc";
import RegVerify from "../Pages/Verification/regVerify";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import DeleteAccount from "../Pages/DeleteAccount";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <TaxiRideDoc /> },
      { path: "authVerify/:token", element: <RegVerify /> },
      { path: "privacy", element: <PrivacyPolicy /> },
      { path: "delete-account", element: <DeleteAccount /> },
    ],
  },
]);